import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { CtLocation } from '../../api/models';

export type TABLE_TYPE = Table<CtLocation>;

export const TABLE = 'ctLocation';
const SCHEMA = 'ctLocationId, sortId';

class CtLocationDatabase implements DataRepository<CtLocation> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<CtLocation | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: CtLocation, key: Key): Promise<CtLocation> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: CtLocation[]): Promise<CtLocation[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<CtLocation[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const CtLocationDB = new CtLocationDatabase(db);
